export default __webpack_public_path__ + "static/media/request-for-return.d2a86e6d.png";